import {createContext, useContext, useMemo} from 'react';
import {isFunction} from 'underscore';

const SwitchContext = createContext<{value: any}>(null);

export function Switch<T>(props: {test: T, children?: any}) {
	const context = useMemo(() => ({value: props.test}), [props.test]);

	return <SwitchContext.Provider value={context}>
		{props.children}
	</SwitchContext.Provider>;
}

export function Case<T>(props: {value: T, children?: any}) {
	const context = useContext(SwitchContext);

	if(context && props.value === context.value) {
		if(isFunction(props.children)) {
			return props.children();
		}

		return props.children;
	}
}
